'use client'
import { useLayoutEffect } from 'react'

/**
 * Stops the page behind a menu from scrolling while it is present. Preserve
 * the native gutter for classic scrollbars so the page does not jump and
 * neither the nav nor its panel paints over only part of the scrollbar space.
 */
export const useSheetScrollLock = (locked: boolean) => {
  useLayoutEffect(() => {
    if (!locked) {
      return undefined
    }
    const root = document.documentElement
    const previous = {
      overflow: root.style.overflow,
      scrollbarGutter: root.style.scrollbarGutter,
    }
    const gutter = window.innerWidth - root.clientWidth
    if (gutter > 0 && !getComputedStyle(root).getPropertyValue('scrollbar-gutter').includes('stable')) {
      root.style.scrollbarGutter = 'stable'
    }
    root.style.overflow = 'hidden'
    return () => {
      root.style.overflow = previous.overflow
      root.style.scrollbarGutter = previous.scrollbarGutter
    }
  }, [locked])
}
